module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BonusWalletView.js"));
	}, "BonusWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BonusWalletView!./src/pages/Shop/Member/Wallet/BonusWallet/BonusWalletView.js
// module id = 1043
// module chunks = 438